import { Component, Input } from '@angular/core';

@Component({
  selector: 'wl-notification-banner',
  templateUrl: './notification-banner.component.html',
  styleUrls: ['./notification-banner.component.less'],
  standalone: false,
})
export class NotificationBannerComponent {
  @Input() translationKey!: string;
  @Input() translationParams?: any;

  constructor() {}
}
